import { media } from './media';
import { api } from './http';
import type { Article } from './types';

export interface ArticleInput {
  title: string;
  standfirst: string;
  body: string;
  category: string;
  access: 'Free' | 'Partial' | 'Paid';
  author: string;
  cover_media_id: number | null;
  meta_description: string;
  slug: string;
  status: 'draft' | 'published';
  featured: number;
  published_at: string | null;
}

export interface MediaItem {
  id: number;
  path: string;
  alt: string;
  width?: number;
  height?: number;
  bytes?: number;
}

export const articles = {
  list: (signal?: AbortSignal) => api.get<{ articles: Article[] }>('/articles', signal),
  get: (id: number) => api.get<{ article: Article & ArticleInput }>(`/articles/${id}`),
  create: (f: ArticleInput) => api.post<{ article: Article }>('/articles', f),
  update: (id: number, f: ArticleInput) => api.put<{ article: Article }>(`/articles/${id}`, f),
  remove: (id: number) => api.del<{ ok: true }>(`/articles/${id}`),
  /** Kept for the article editor; the same upload as `media.upload`. */
  upload: (file: File, alt = '') => media.upload(file, alt),
};
